import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
`;

export const StyledSearchInput = styled.input`
    width: ${props => (props.size ? '157px' : '100%')};
    height: 30px;

    background-color: rgba(239, 240, 242, 0.18);
    border-radius: 3px;

    font-size: 14px;
    color: #fff;
    border: none;
    outline: none;
    font-weight: 400;
    // text-align: center;
    padding-left: 10px;

    &:placeholder {
        color: #c5cacf;
        font-weight: 200;
    }
`;

export const DiscardButtonContainer = styled.div`
    cursor: default;
    position: absolute;
    top: 32%;
    right: 3px;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/SearchInput/style.js